// The full-panel loading animation, shown while a skill or session is being fetched.
//
// This markup was copy-pasted into five screens - identical in every one, down to the size and
// the wrapper classes - so the look is defined here once and nowhere else. It renders exactly
// what those five rendered; only the duplication is gone.
//
// The one variable is which theme's loader.json plays. Pass `theme` when the caller already
// knows it (a screen resolves one in its constructor, before applyTheme has run); omit it in
// shared chrome and it reads the live theme from the <html> stamp applyTheme sets.

import { Player } from "@lottiefiles/react-lottie-player";
import { loaderSrc, Theme } from './theme';

export const Loader = ({ theme }: { theme?: Theme }) => (
  <div className='preloader d-flex align-items-center justify-content-center'>
    <Player id={"loaderAnimation"} autoplay loop style={{ "width": "40%", "height": "30%" }} speed={1} src={loaderSrc(theme)}></Player>
  </div>
);
